import { IconFileText } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import IwocaPayBackdrop from 'svg/IwocaPayBackdrop';
import {
  getUnlockURL,
  IWOCAPAY_ACCOUNTANTS_URL,
  IWOCAPAY_BROKERS_URL,
} from '../ProductsUK.helpers';
import styles from './IwocaPayWidget.module.css';

export const IwocaPayWidget = () => {
  const { introducerType, availableProducts } = useIntroducerData();
  const hasIwocaPay = availableProducts?.includes('iwocapay');

  if (!introducerType) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.info}>
          <h3>iwocaPay</h3>
          <p className={styles.description}>
            Get your clients their invoices paid sooner by offering flexible
            payment options without the risk.
          </p>
        </div>
        <dl className={styles.details}>
          <li>
            <dt>Spread the cost over</dt>
            <dd>3 months for 4%</dd>
          </li>
          <li>
            <dt>Settle up in</dt>
            <dd>seconds for free</dd>
          </li>
          <li>
            <dt>Invoices up to</dt>
            <dd>£15,000</dd>
          </li>
        </dl>
        <div className={styles.actions}>
          <Button
            variant="tertiary"
            target="_blank"
            rel="noreferrer"
            href={
              introducerType === 'accountant'
                ? IWOCAPAY_ACCOUNTANTS_URL
                : IWOCAPAY_BROKERS_URL
            }
          >
            <IconFileText />
            iwocaPay guide
          </Button>
          <Button
            target="_blank"
            rel="noreferrer"
            href={
              hasIwocaPay
                ? 'https://share.hsforms.com/1iAgfTUnoR4a4_qzyDEdGGA3rrot'
                : getUnlockURL('iwocaPay', introducerType)
            }
          >
            {hasIwocaPay ? 'Refer clients to iwocaPay' : 'Unlock iwocaPay'}
          </Button>
        </div>
      </div>
      <IwocaPayBackdrop className={styles.backdrop} />
    </div>
  );
};
